import { Box, Stack, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import moment from "moment";
import React from "react";
import { ReactComponent as LinkedInIcon } from "../../../assets/icons/linkedin.svg";
import { scrollbarStyle } from '../../../shared/dashboard';
import { EmailBody } from "../../../types/files";

const useStyles = makeStyles((theme) => ({
    card: {
        width: '100%',
        minWidth: 450,
        maxWidth: 'calc(33vw - 80px)',
        height: 'fit-content',
        padding: 16,
        borderRadius: 24,
        backgroundColor: '#fff',
        border: `1px solid ${theme.colors.neutral['500']}`,
        boxShadow: '0px 3px 5px -1px rgba(16, 24, 40,0.2)',
        transition: '0.05s ease-in-out',
        "&:hover": {
            boxShadow: '0px 3px 5px -1px rgba(16, 24, 40,0.2), 0px 5px 8px 0px rgba(16, 24, 40,0.14), 0px 1px 14px 0px rgba(16, 24, 40,0.12)',
        },
    },
    title: {
        display: '-webkit-box',
        width: 'fit-content',
        fontSize: '1.1rem',
        fontFamily: 'Poppins',
        overflow: 'hidden',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        textOverflow: 'ellipsis',
        textTransform: 'capitalize',
        maxWidth: '24ch',
    },
    bodyContentBlock: {
        width: '100%',
        height: 'fit-content',
        minHeight: '100px',
        maxHeight: '300px',
        overflowY: 'auto',
        padding: '8px',
    },
    subject: {
        display: '-webkit-box',
        width: 'fit-content',
        fontFamily: 'Poppins',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: theme.colors.neutral['500'],
        overflow: 'hidden',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        textOverflow: 'ellipsis',
        textTransform: 'capitalize',
        maxWidth: '40ch',
        wordBreak: 'break-all',
    },
    timestamp: {
        fontFamily: 'Inter',
        fontSize: '0.75rem',
        fontWeight: 500,
        color: theme.colors.neutral['600'],
        textAlign: 'right',
    },
    textField: {
      width: '100%',
      height: '100%',
      padding: '12px',
      border: '1px solid darkgray',
      borderRadius: 8,
      background: 'transparent',
      overflowY: 'auto',
      "&:active": {
        borderColor: 'darkgreen !important',
      },
      ...scrollbarStyle,
    },
    sender: {
      fontFamily: 'Inter',
      fontSize: '0.95rem',
      fontWeight: 'bold',
      color: `${theme.colors.neutral['700']} !important`,
    },
    message: {
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: '400',
      color: `${theme.colors.neutral['600']} !important`,
      wordBreak: 'break-word',
      whiteSpace: 'pre-line',
      textAlign: 'left',
    },
}));

const LinkedInMessage: React.FC<{
    content: EmailBody & {threads: ({ timestamp: string|null, sender?: string, message: string })[]},
}> = ({ content }) => {
    const classes = useStyles();

    return (<>
        <Box className={classes.card}>
            <Stack direction="row" alignItems="flex-start" width="100%" >
                <Box width="40px" mt="6px" pl="2px">
                    <LinkedInIcon  style={{ width: 28, height: 28, fill: "#7bd4d4" }} />
                </Box>
                <Stack direction="column" spacing="4px" alignItems="flex-start" justifyContent="center" width="100%" py={1}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" pl={1} width="100%">
                        <Typography className={classes.subject} width="100%">
                            {'LinkedIn Message'}
                        </Typography>
                        <Typography className={classes.timestamp} width="30%">
                            {`${moment(content?.createdAt).fromNow()}`}
                        </Typography>
                    </Stack>
                    <Box width="100%" height="100%" pt={1}>
                        <Stack className={classes.bodyContentBlock}>
                            <Stack className={classes.textField} alignItems="stretch" justifyContent="flex-start">
                                {content.threads.map((thread, i) => (
                                    <Stack alignItems="flex-start" justifyContent="flex-start" width="100%"
                                        key={'linkedin-messages-125-' + i}>
                                        {!!thread.sender && (
                                            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                                                <Typography className={classes.sender} mt={1}>
                                                    {`${thread.sender}`}
                                                </Typography>
                                                {/* {!!thread.timestamp && (
                                                    <Typography className={classes.timestamp}>
                                                        {moment(`${thread.timestamp}`).format('MMM D, Y HH:mm')}
                                                    </Typography>
                                                )} */}
                                            </Stack>
                                        )}
                                        <Typography className={classes.message}>
                                            {`${thread.message}`}
                                        </Typography>
                                    </Stack>
                                ))}
                            </Stack>
                        </Stack>
                    </Box>
                </Stack>
            </Stack>
        </Box>
    </>);
};

export default LinkedInMessage;
